import React from "react";
import "../../styles/components/SponsorCard.scss";
import SliderPanel from "../SliderPanel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle, faTimes } from "@fortawesome/pro-light-svg-icons";
const RulesAndRegulationSlider = (props) => {
  const { setrulesAndRegulationSlide, rulesAndRegulationSlide } = props;

  return (
    <SliderPanel
      isOpen={rulesAndRegulationSlide}
      size="45"
      showCancel={false}
      backdropClicked={() => setrulesAndRegulationSlide(false)}
    >
      <div className="disp-flex-col">
        <div className="disp-flex-row space-between fw-500 ft-16 Border-Bottom ">
          <p>Rules And Regulations</p>
          <FontAwesomeIcon
            icon={faTimes}
            style={{ cursor: "pointer" }}
            onClick={() => setrulesAndRegulationSlide(false)}
          />
        </div>
        <div className="ft-16 fw-500 mt-15 mb-20">Special tax notice</div>
        <ul>
          <li>
            You must read the “Special Tax Notice Regarding Plan Payments”
            before requesting your withdrawal since withdrawals may be taxable
            and restrictions, penalties and other taxes may apply.
          </li>
          <li>
            You have 30 days from the date of receiving this Special Tax Notice
            to decideto have your distribution made payable as a direct rollover
            to an IRA, Roth IRA or an eligible employer plan, or made payable to
            you.
          </li>
          <li>
            If you want to waive the 30-day notice period and have your
            distribution from the plan made as soon as possible in accordance
            with your request, review and confirm the following:
            <br />
            - I acknowledge receipt of a written "Special Tax Notice Regarding
            Plan Payments” that provides the various distribution options
            available to me.
            <br />
            - I understand that I am entitled to a reasonable period of not less
            than 30 days from the date the notice was provided to me in order to
            decide whether to make or not make a direct rollover of my
            distribution.
            <br />- Even with my waiver, I continue to have the opportunity
            within the 30-day period to reconsider my decision of whether or not
            to elect a direct rollover until my request is actually processed.
          </li>
        </ul>
        <div className="ft-16 fw-500 mb-20">
          Distribution rules for all sources
        </div>
        <ul>
          <li>
            You must read the following distribution rules for all sources
            before you proceed.
            <br />
            - If you have not reached age 59½, you may also have to pay a 10%
            early withdrawal penalty tax on the taxable portion of your
            withdrawal, if you do not roll over the taxable portion. For
            Rollover the amount the early withdrawal tax will not be calculated.
            <br />
            - Redemption Fees may be deducted from your account because of your
            withdrawal request.
            <br />
            - f you roll over after-tax contributions to a traditional IRA, it
            is your responsibility to track and report to the IRS (on the
            appropriate IRS Forms) the amount of the after- tax contributions
            (original amounts made, without any earnings or losses).
            <br />
            - If you are married, your spouse must give notarized consent to
            your in-service withdrawal request. This applies even if you are
            legally separated from your spouse.
            <br />
            - Before your withdrawal request is processed, your employer must
            approve the request
            <br />- A withdrawal request service fee of $1.00 will be charged to
            your account/ deducted from the withdrawal amount.
          </li>
        </ul>
      </div>
    </SliderPanel>
  );
};

export default RulesAndRegulationSlider;
